/**
 * SuggestedQuestions — floating card of clickable suggestion chips.
 *
 * Extracted from ChatPanel.tsx (legacy) for use by AgUiChatPanel. ChatPanel.tsx
 * keeps its own local copy — this file is AG-UI-only. If the two panels ever
 * converge, promote this out of /agui and drop the legacy copy.
 */

import { useTranslation } from 'react-i18next';

interface SuggestedQuestionsProps {
  questions: string[];
  onSelect: (q: string) => void;
}

export default function SuggestedQuestions({ questions, onSelect }: SuggestedQuestionsProps) {
  const { t } = useTranslation('chat');
  return (
    <div className="chat-panel__suggestions-wrap">
      <div className="chat-panel__suggestions">
        <div className="chat-panel__suggestions-title">
          <span className="chat-panel__suggestions-icon">💡</span>
          <span>{t('suggestions.title')}</span>
        </div>
        <div className="chat-panel__suggestions-list">
          {questions.map((q, idx) => (
            <button
              key={idx}
              className="chat-panel__suggestion-chip"
              onClick={() => onSelect(q)}
              title={q}
            >
              {q}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}